<template>
<!--  Need to use none transition or there's some weird bug about transition with the ace editors that really messes things up
      cpu goes full throttle for like 20 seconds before it shows. -->
  <q-dialog v-model="opened" @show="onShow" transition-show="none" transition-hide="none">
    <q-card :style="{minWidth: '60vw', minHeight: '60vh', maxHeight: '60vh', maxWidth: '80vw'}">
      <q-card-section class="q-pa-sm">
      <q-toolbar>
          Search
        <div>
          <q-checkbox @input="onSearchChange" v-model="matchCase" label="Match Case" />
          <q-checkbox @input="onSearchChange" v-model="wordSearch" label="Words" />
          <q-checkbox @input="onSearchChange" v-model="regexSearch" label="Regex" />
          <q-checkbox @input="onSearchChange" v-model="searchAllNotes" label="Search All Notes (Not just this session)" />
        </div>
      </q-toolbar>
      <q-toolbar>
        <q-input ref="searchBox" inverted v-model="searchTerm"
                 @keyup.down="downPressed"
                 @keyup.up="upPressed"
                 @keyup.enter="enterPressed"
                 @input="onSearchChange" color="none" :debounce="50" placeholder="Search" style="width: 100%;"/>
      </q-toolbar>
      </q-card-section>
      <q-card-section class="q-pa-none">
        <q-scroll-area style="height: 45vh">
          <q-infinite-scroll @load="loadMore" ref="infiniteScroll">
            <q-list class="layout" separator>
              <search-result v-for="(match, i) in displayedMatches" :key="i"
                             :match="match" :searchTerm="searchTerm" :active="selectedId==i"/>
            </q-list>
          </q-infinite-scroll>
        </q-scroll-area>
      </q-card-section>
    </q-card>
  </q-dialog>
</template>

<script>
import firebase from 'firebase/app'
import 'firebase/auth'
import { allNoteHelpers, getChildren } from '../js/noteTemplates/noteHelpers'
import SearchResult from '../components/SearchResult'

export default {
  name: 'SearchModal',
  components: {
    'search-result': SearchResult
  },
  data () {
    return {
      matches: [],
      displayedMatches: [],
      matchCase: false,
      wordSearch: false,
      regexSearch: false,
      searchAllNotes: false,
      runningSearch: false,
      shouldRestartSearch: true,
      mousetrap: null,
      selectedId: null
    }
  },
  computed: {
    opened: {
      get () { return this.$store.state.ui.searchOpen },
      set (v) { this.$store.commit('setSearchOpen', v) }
    },
    settings () { return this.vuexUser.settings },
    searchTerm: {
      get () { return this.$store.state.ui.searchTerm },
      set (v) { this.$store.commit('setSearchTerm', v) }
    },
    user () {
      return firebase.auth().currentUser
    },
    vuexUser () {
      return this.$store.state.auth.currentUser
    },
    notesToSearch () {
      let unorderedNotes
      if (this.searchAllNotes) {
        unorderedNotes = allNoteHelpers()
      } else {
        const rootNoteId = this.getSession().rootNoteId
        unorderedNotes = rootNoteId ? getChildren(rootNoteId) : allNoteHelpers()
      }
      unorderedNotes.sort((a, b) => {
        const ta = a.note.updatedAt
        const tb = b.note.updatedAt
        if (ta < tb) {
          return 1
        } else if (ta > tb) {
          return -1
        }
        return 0
      })
      return unorderedNotes // which is now sorted
    }
  },
  methods: {
    getSession () {
      return this.$store.state.auth.currentUser.sessions[sessionStorage.getItem('userSessionIndex') || 0] || {}
    },
    loadMore (index, done) {
      console.log('load_more')
      console.log(this.matches.length)
      this.displayedMatches = this.matches.slice(0, index * 10)
      const end = index * 10 >= this.matches.length
      done(end)
    },
    singleSearch (noteHelper, searchTerm) {
      let content = (noteHelper.note || {}).data
      if (!content) return

      if (searchTerm instanceof RegExp) {
        let res = searchTerm.exec(content)
        if (!res) return
        this.matches.push({ noteHelper: noteHelper, index: res.index, len: res[0].length })
      } else {
        if (!this.matchCase) content = content.toLowerCase()
        let matchIndex = content.indexOf(searchTerm)
        if (matchIndex > -1) {
          this.matches.push({ noteHelper: noteHelper, index: matchIndex, len: searchTerm.length })
        }
      }
    },
    search () {
      this.matches = []
      let searchTerm = (!this.matchCase && !this.regexSearch) ? this.searchTerm.toLowerCase() : this.searchTerm
      // console.log(searchTerm)
      if (!searchTerm) {
        this.runningSearch = false
        this.shouldRestartSearch = false
        return
      }

      if (this.regexSearch) {
        try {
          searchTerm = new RegExp(searchTerm, 'g' + (!this.matchCase ? 'i' : ''))
        } catch (ex) {
          console.warn(ex)
          return
        }
      }
      this.notesToSearch.some((noteHelper) => {
        this.singleSearch(noteHelper, searchTerm)
        if (this.shouldRestartSearch) return true
      })
    },
    onSearchChange () {
      if (this.runningSearch) {
        this.shouldRestartSearch = true
        setTimeout(this.onSearchChange.bind(this), 100)
        // console.log('abort_search')
        return
      }

      this.runningSearch = true
      // console.log('starting search')
      // console.log(allNoteHelpers().length)
      this.search()
      // console.log(this.matches.length)
      this.$refs.infiniteScroll.reset()
      this.$refs.infiniteScroll.resume()
      this.$refs.infiniteScroll.trigger()
      this.shouldRestartSearch = false
      this.runningSearch = false
      // console.log('finished search')
    },
    onShow () {
      this.selectedId = 0
      this.$nextTick(() => {
        this.$refs.searchBox.select()
        this.$refs.searchBox.focus()
      })
    },
    isVis (item) {
      return item.indexOf(this.searchTerm) >= 0
    },
    saveSettings () {
      this.$store.dispatch('updateCurrentUser')
    },
    upPressed () {
      if (this.selectedId === 0) this.selectedId = null
      else this.selectedId -= 1
    },
    downPressed () {
      if (this.selectedId == null) this.selectedId = 0
      else this.selectedId += 1
    },
    enterPressed () {
      const match = this.matches[this.selectedId]
      if (!match) return
      this.$store.commit('updateSelectedTreeItemId', match.noteHelper.noteId)
      this.$router.push('/home/' + match.noteHelper.noteId)
      this.$store.commit('setSearchOpen', false)
    }
  },
  mounted () {
    // this.mousetrap = new Mousetrap(this.$el)
    // this.mousetrap.bind(['shift+z'], () => {
    //   if (this.selectedId == null) this.selectedId = 1
    //   else this.selectedId += 1
    //   console.log('we did it')
    //
    //   // return false to prevent default browser behavior
    //   // and stop event from bubbling
    //   return false
    // })
  }
}
</script>

<style lang="styl">
</style>
